/**
 * Saga集合
 */
import list from './list/model';
import picturenickname from './picturenickname/model';

export default [
    ...Object.values(list.sagas),
    ...Object.values(picturenickname.sagas)
];